var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"#e8eaed"}},[_c('path',{attrs:{"d":"M320-240L80-480l240-240 57 57-184 184 183 183-56 56zm320 0l-57-57 184-184-183-183 56-56 240 240-240 240z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }